import { createWithPersistAndImmer } from '@amzn/woot-services-vendor-portal-core/utils/stores'
import { create as _create } from 'zustand'

export type DarkModeSetting = 'auto' | 'dark' | 'light'
export type ReactQueryDevToolsSetting = 'show' | 'hide'

export type App = {
  darkMode: DarkModeSetting
  isLoading: boolean
  reactQueryDevTools: ReactQueryDevToolsSetting
}

type AppStore = {
  app: App
  onToggleReactQueryDevtools: () => void
  onSetDarkMode: (value: DarkModeSetting) => void
  onSetIsLoading: (value: boolean) => void
  reset: () => void
}

const initialAppState: App = {
  darkMode: 'auto',
  isLoading: false,
  reactQueryDevTools: 'hide',
}

export const useAppStore = createWithPersistAndImmer<AppStore>(
  (set) => ({
    app: initialAppState,
    onSetDarkMode: (value: DarkModeSetting) => {
      set((state) => {
        state.app.darkMode = value
      })
    },
    onSetIsLoading: (value: boolean) => {
      set((state) => {
        state.app.isLoading = value
      })
    },
    onToggleReactQueryDevtools: () => {
      set((state) => {
        state.app.reactQueryDevTools =
          state.app.reactQueryDevTools === 'hide' ? 'show' : 'hide'
      })
    },
    reset: () =>
      set((state) => {
        state.app = initialAppState
      }),
  }),
  { name: 'app-store' },
)
